module.exports = __webpack_public_path__ + "static/media/expensesIcon.c7cfd98d.svg";